import Record from '@/base/model/record';

class MailTemplate extends Record {

    static moduleName = 'mailtemplate';

    async createMail(callback) {
        let res = await api.post('/api/mailtemplate/create_mail', JSON.stringify({
            id: this.id,
        })); 
        if (res && callback) {
            callback(null, {route: {table: 'mail', id: res, 'name': 'record'}});
        }
    }
}


export default MailTemplate;
